export interface ApiError {
  message: string,
  errorCode?: number,
  statusCode?: number,
  status?: string,
}

export const DefaultError = {
  message: 'Unknown Error',
}